
// Angular
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ChangeDetectorRef, ViewRef } from '@angular/core';
import { FavoritesService } from 'app/core/favorites/_services/favorites.service';
// RxJS
import { Subscription } from 'rxjs';
// Layout
import { MenuAsideService, SubheaderService } from '../../../../../core/_base/layout';
import { Breadcrumb } from '../../../../../core/_base/layout/services/subheader.service';
import { LayoutUtilsService } from 'app/core/_base/crud';
import { Favorites } from 'app/core/favorites/models/favorites.model';
import { Router } from '@angular/router';
import { CustomerSupportComponent } from 'app/views/pages/community/customer-support/customer-support.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthorizationService } from 'app/core/ana/authorization';
import { finalize } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Component({
  standalone: false,
    selector: 'kt-subheader3',
    templateUrl: './subheader3.component.html',
    styleUrls: ['./subheader3.component.scss']
})
export class Subheader3Component implements OnInit, OnDestroy, AfterViewInit {
    // Public properties
    @Input() fluid: boolean;
    @Input() clear: boolean;
	username = ((localStorage.getItem('user')) ? localStorage.getItem('user') : '') as string;

    today: number = Date.now();
    title = '';
    desc = '';
	breadcrumbDashboard = '';
    breadcrumbs: Breadcrumb[] = [];
    actual:Breadcrumb;
	isfavorite: boolean;
    // Private properties
    private subscriptions: Subscription[] = [];
	customerSupportDialogOpened: boolean = false;
	hasFyffesPediaAccess : boolean = false;

    /**
     * Component constructor
     *
     * @param subheaderService: SubheaderService
     */
    constructor(
        public subheaderService: SubheaderService,
        private changeDetectorRef: ChangeDetectorRef,
		private favoritesService: FavoritesService,
		private menuAsideService: MenuAsideService,
		private router: Router,
		private layoutUtilsService: LayoutUtilsService,
		private readonly dialog: MatDialog,
		private authorization: AuthorizationService
    ) {
    }

    /**
     * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
     */

    /**
     * On init
     */
    ngOnInit() {
		this.authorization.isAuthorized(this.username, '/chatgpt', environment.ipserver+'fyffesna/communityApps')
		.pipe(finalize(() => { }))
		.subscribe(
		  isAuthorized => {
			this.hasFyffesPediaAccess = isAuthorized;
		  }
		);
    }

    /**
     * After view init
     */
    ngAfterViewInit(): void {
        this.subscriptions.push(this.subheaderService.title$.subscribe(bt => {
            // breadcrumbs title sometimes can be undefined
            if (bt) {
                Promise.resolve(null).then(() => {
                    this.title = bt.title;
                    this.desc = bt.desc;
					this.breadcrumbDashboard = '';
					if(this.title.split(' ').length > 1 && this.title.split(' ')[0] === 'Dashboard') {
						this.title.split(' ').forEach( (text: string, index: number) => {
							if(index > 0) {
								this.breadcrumbDashboard = this.breadcrumbDashboard + ' ' + text;
							}
						});
						this.title = this.title.split(' ')[0];
					}
                });
            }
        }));

        this.subscriptions.push(this.subheaderService.breadcrumbs$.subscribe(bc => {
            Promise.resolve(null).then(() => {
                this.breadcrumbs = bc;
				if( this.breadcrumbs.length > 0) {
					this.actual = this.breadcrumbs[this.breadcrumbs.length -1];
					this.validateFavorite(this.actual.page);
				}

                this.updateDOM();
            });
        }));
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        this.subscriptions.forEach(sb => sb.unsubscribe());
    }

    /**
     * Force a refresh in the dom
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-03-24
     */
    private updateDOM() {
        if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
            this.changeDetectorRef.detectChanges();
        }
    }

	reloadCurrentPage() {
		// window.location.reload();
		this.menuAsideService.loadMenu();
		let currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}

  	registerFavorite(url: string) {
		var newarr = url.split("/");
		var uri = url.replace("/"+newarr[1],'')
		this.favoritesService.findComponentByUrl(uri)
		.pipe(

		)
		.subscribe(
			data => {
				let favorite : Favorites = new Favorites();
				favorite.username = localStorage.getItem('user');
				favorite.idComponent = data;
				this.favoritesService.register(favorite)
					.pipe(

						)
					.subscribe(
					data => {
						this.validateFavorite(url);
						this.reloadCurrentPage();
						this.showModalAlert("Component was successfully added to favorites");
						}
		);
			}
		);
	}

	removeFavorite(url: string) {
		var newarr = url.split("/");
		var uri = url.replace("/"+newarr[1],'')
		this.favoritesService.findComponentByUrl(uri)
		.pipe(

		)
		.subscribe(
			data => {
				let favorite : Favorites = new Favorites();
				favorite.username = localStorage.getItem('user');
				favorite.idComponent = data;
				this.favoritesService.remove(favorite)
					.pipe(

						)
					.subscribe(
					data => {
						this.validateFavorite(url);
						this.reloadCurrentPage();
						this.showModalAlert("Component was successfully removed to favorites");
						}
		);
			}
		);
	}

 	validateFavorite(url: string) {
		var newarr = url.split("/");
		var uri = url.replace("/"+newarr[1],'')
		this.favoritesService.findComponentByUrl(uri)
		.pipe(

		)
		.subscribe(
			data => {
				let favorite : Favorites = new Favorites();
				favorite.username = localStorage.getItem('user');
				favorite.idComponent = data;
				this.favoritesService.validateComponent(favorite.username,favorite.idComponent.toString())
					.pipe(

						)
					.subscribe(
					data => {
						this.isfavorite = data;
						this.updateDOM();
						}
		);
			}
		);
	}

	/**
     * Showing general message in alert/dialog window
     * @param message string to show
     * @author Castor Transformación Digital - Juan G. Pavas
     * @since 2019-10-31
     */
	 private showModalAlert(message: string) {
        const modalRef = this.layoutUtilsService.generalAlert();
        modalRef.componentInstance.data = message;
    }

	onCustomerSupportOpen(): void {
		if (this.customerSupportDialogOpened) {
		  return;
		}

		this.customerSupportDialogOpened = true;

		this.dialog
		  .open(CustomerSupportComponent, {
			width: '400px',
			disableClose: false,
			panelClass: 'mat-dialog-customer-support-modal',
			autoFocus: false,
			hasBackdrop: false,
		  })
		  .afterClosed()
		  .subscribe(() => {
			this.customerSupportDialogOpened = false;
		  });
	  }

}
